import Button from "@material-tailwind/react/components/Button";
import { FaArrowCircleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function WelcomeList() {
  const navigate = useNavigate();
  const instructionSteps = [
    {
      title: "Set up your profile",
      content: "Share basic info about yourself or company to help stand out.",
    },
    {
      title: "Show us what your boats look like",
      content:
        "Upload pictures from every angle of your boat to get a better outreach",
    },
    {
      title: "Finish up and publish",
      content: "Add pricing and availability and publish your listing",
    },
  ];

  return (
    <div className="md:w-[60%] md:m-24 m-10">
      
      {instructionSteps.map((item, index) => {
        return (
          <div key={index} className="my-10">
            <div className="flex items-center text-lg ">
              <FaArrowCircleRight /> <p className="m-3">{item.title}</p>
            </div>
            <p className="font-light text-gray-600 ml-6 ">{item.content}</p>
          </div>
        );
      })}
      <div className="mt-5">
        <Button  placeholder={undefined} 
          onClick={() => navigate("/signIn")}
          className="px-11 ml-6 bg-primary py-2"
        >
          GET STARTED
        </Button>
      </div>
    </div>
  );
}

export default WelcomeList;
